import { Color } from '@persona-id/design-tokens';
import { QRCodeSVG } from 'qrcode.react';

const QrCode = ({
  value,
  accessibleTitle,
  'data-test': dataTest,
  bgColor,
  fgColor,
}: {
  value: string;
  accessibleTitle: string;
  'data-test'?: string;
  bgColor?: string;
  fgColor?: string;
}) => {
  if (value == null) {
    return null;
  }

  return (
    <QRCodeSVG
      value={value}
      title={accessibleTitle}
      data-test={dataTest}
      includeMargin
      // White instead of transparent for backwards compatibility.
      // These colors weren't always stylable, and some customers have dark BGs.
      bgColor={bgColor ?? Color.PrimaryWhite}
      fgColor={fgColor}
    />
  );
};

export default QrCode;
